module.exports = __webpack_public_path__ + "static/media/energy-efficiency.49af9575.png";